export default __webpack_public_path__ + "static/media/logo-maia.1c610892.svg";